export const claimState = [
  {
    value: 'accepted',
    label: 'Accepted'
  },
  {
    value: 'acknowledged',
    label: 'Acknowledged'
  },
  {
    value: 'ready',
    label: 'Ready'
  },
  {
    value: 'draft',
    label: 'Draft'
  },
  {
    value: 'rejected',
    label: 'Rejected'
  },
  {
    value: 'denied',
    label: 'Denied'
  },
  {
    value: 'paid',
    label: 'Paid'
  },
  {
    value: 'no_payment',
    label: 'No Payment'
  },
  {
    value: 'cancelled',
    label: 'Canceled'
  },
  {
    value: 'no_show',
    label: 'No Show'
  },
  {
    value: 'not_created',
    label: 'No Claim'
  }
];

export const superbillStatus = [
  {
    value: 'completed',
    label: 'Scrubbed'
  },
  {
    value: 'pending',
    label: 'Not Scrubbed'
  },
  {
    value: 'incomplete',
    label: 'Not Created'
  },
  {
    value: 'cancelled',
    label: 'Canceled'
  },
  {
    value: 'no_show',
    label: 'No Show'
  }
];

export const claimsStatusCodes = [
  { value: '1', label: '1 - Processed as Primary' },
  { value: '2', label: '2 - Processed as Secondary' },
  { value: '3', label: '3 - Processed as Tertiary' },
  { value: '4', label: '4 - Denied' },
  { value: '19', label: '19 - Processed as Primary, Forwarded to Additional Payer(s)' },
  { value: '20', label: '20 - Processed as Secondary, Forwarded to Additional Payer(s)' },
  { value: '21', label: '21 - Processed as Tertiary, Forwarded to Additional Payer(s)' },
  { value: '22', label: '22 - Reversal of Previous Payment' }
];

export const insurancePatientRelation = [
  {
    label: 'Self',
    value: '18'
  },
  {
    label: 'Spouse',
    value: '01'
  },
  {
    label: 'Child',
    value: '19'
  },
  {
    label: 'Employee',
    value: '20'
  },
  {
    label: 'Unknown',
    value: '21'
  },
  {
    label: 'Organ Donor',
    value: '39'
  },
  {
    label: 'Cadaver Donor',
    value: '40'
  },
  {
    label: 'Life Partner',
    value: '53'
  },
  {
    label: 'Other Relationship',
    value: 'G8'
  }
];

export const insurance_type = [
  { value: 'primary', label: 'Primary' },
  { value: 'secondary', label: 'Secondary' },
  { value: 'tertiary', label: 'Tertiary' },
  { value: 'quaternary', label: 'Quaternary' },
  { value: 'quinary', label: 'Quinary' }
];

export const claim_md_marital_status = [
  {
    value: 'S',
    label: 'Single'
  },
  {
    value: 'M',
    label: 'Married'
  },
  {
    value: 'O',
    label: 'Other'
  }
];

export const claim_md_employment_type = [
  {
    value: 'E',
    label: 'Employed'
  },
  {
    value: 'F',
    label: 'Full-Time Student'
  },
  {
    value: 'P',
    label: 'Part-Time Student'
  }
];

export const claim_md_genders = [
  {
    value: 'M',
    label: 'Male'
  },
  {
    value: 'F',
    label: 'Female'
  },
  {
    value: 'U',
    label: 'Unknown'
  }
];
